module.exports = __webpack_public_path__ + "img/coming-soon.e176fc16.png";